import type { TabsterDOMAttribute } from "@fluentui/react-tabster";
import { useTabsterAttributes } from "@fluentui/react-tabster";

export function useDisableTabTabster(): TabsterDOMAttribute {
  return useTabsterAttributes({
    root: {},
    focusable: {
      ignoreKeydown: {
        Tab: true,
      },
    },
  });
}
